// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import { loadStripe, type Stripe } from '@stripe/stripe-js';
import { getConfig } from '../config';

let promise: Promise<Stripe | null> | undefined;

/**
 * Lazily loads Stripe.js once and caches the resulting promise.
 * Throws synchronously if VITE_STRIPE_PUBLISHABLE_KEY is missing — callers
 * must catch from the call site (e.g. AddCardModal's open effect).
 */
export function getStripePromise(): Promise<Stripe | null> {
  if (!promise) {
    const key = getConfig().stripePublishableKey;
    if (!key) {
      throw new Error('VITE_STRIPE_PUBLISHABLE_KEY is not set');
    }
    promise = loadStripe(key);
  }
  return promise;
}
